import * as moment from 'moment';

import {
  Inject,
  Injectable,
} from 'ng-metadata/core';

import { ApiService } from 'services/api.service';

@Injectable()
export class AuthNetService {
  public key = process.env.MIX_AUTHNET_KEY;
  public login = process.env.MIX_AUTHNET_LOGIN;

  constructor(
    @Inject('$q') private $q: ng.IQService,
    @Inject('$window') private $window,
  ) {}

  getNonce(card, merchant) {
    if (!card || !card.number || !merchant) {
      return;
    }

    const secureData = {
      authData: {
        clientKey: merchant.token,
        apiLoginID: merchant.login_id,
      },
      cardData: {
        cardNumber: card.number,
        month: String(card.exp.month),
        year: moment(card.exp.year, 'YYYY').format('YY'),
        cardCode: card.csc,
      },
    };

    const defer = this.$q.defer();

    if (this.$window.Accept && this.$window.Accept.dispatchData) {
      this.$window.Accept.dispatchData(secureData, (response) => {
        if (response.messages && response.messages.resultCode === 'Error') {
          defer.reject(response.messages.message);
        }

        defer.resolve(response.opaqueData);
      });
    }

    return defer.promise;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/auth-net.service.ts